module.exports = __webpack_public_path__ + "static/media/2.8eb5d2b1.JPG";